import React from "react";

const NotFound: React.FC = () => {
  return (
    <>
      <p>ページが存在しないURLです</p>
    </>
  );
};
export default NotFound;